import { useLocation, useNavigate } from "react-router-dom";
import {
  getFallbackBackLabel,
  useNavigationHistory,
} from "@/contexts/NavigationHistoryContext";

interface UseBackNavigationOptions {
  fallbackLabel?: string;
}

export function useBackNavigation(options: UseBackNavigationOptions = {}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { previousLabel } = useNavigationHistory();
  const stateReturnLabel = (location.state as { returnLabel?: string } | null)
    ?.returnLabel;

  // An explicit returnLabel from the navigating screen wins: it names where the
  // user actually came from. Browser history is only a fallback, because it
  // holds a previous entry on almost every navigation and used to mask it.
  return {
    backLabel:
      stateReturnLabel ??
      previousLabel ??
      options.fallbackLabel ??
      getFallbackBackLabel(location.pathname),
    goBack: () => navigate(-1),
  };
}
